import { BuyerLink } from '@choco-admin/types';
import { Divider } from '@heroui/react';
import React from 'react';

import { BuyerLinkingField } from '../../BuyerLinking';
import { SupplierLinkingField } from '../../SupplierLinking';
import { UserFormUser } from '../hooks';

interface UserLinkingSectionProps {
  user: UserFormUser;
  userBuyers: BuyerLink[];
  disabled?: boolean;
}

export const UserLinkingSection: React.FC<UserLinkingSectionProps> = ({
  user,
  userBuyers,
  disabled = false,
}) => {
  return (
    <>
      <BuyerLinkingField
        userId={user.id}
        userName={user.name || ''}
        initialLinkedBuyers={userBuyers.map((buyer) => ({
          value: buyer.id,
          label: `${buyer.name}-${buyer.referenceId || 'N/A'} (${
            buyer.fullAddress || 'No address'
          })`,
          metaData: {
            rolesEnabled: buyer.rolesEnabled,
            buyerUserRole: buyer.role,
          },
        }))}
        disabled={disabled}
      />
      <Divider />

      <SupplierLinkingField
        userId={user.id}
        userName={user.name || ''}
        initialLinkedSupplier={
          user.supplierName
            ? {
                value: user.supplierId || '',
                label: `${user.supplierName}-${
                  user.supplierReferenceId || 'N/A'
                } (No address)`,
              }
            : null
        }
        disabled={disabled}
      />
      <Divider />
    </>
  );
};
